module.exports = __webpack_public_path__ + "static/media/8. Compaginar 3, Óleo y resina cristal en tela, 100 x 120 cm, 2019 copy.4b4ee6b2.png";